import { Link } from "react-router-dom";
import { MAIN_SITE_URL } from "@/utils/constants";

const articles = [
  {
    slug: "/artykul/czy-kakobuy-jest-bezpieczny",
    title: "Czy Kakobuy jest bezpieczny?",
    desc: "Kompletny poradnik bezpieczeństwa dla polskich kupujących. Sprawdzone metody weryfikacji sprzedawców i ochrona przed oszustwami.",
    tag: "Bezpieczeństwo",
    tagIcon: "ri-shield-check-line",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20laptop%20showing%20security%20shield%20icon%2C%20warm%20cream%20desk%2C%20soft%20morning%20light%2C%20clean%20modern%20aesthetic%2C%20trust%20and%20protection%20concept%2C%20warm%20beige%20tones%2C%20calm%20reassuring%20atmosphere%2C%20european%20lifestyle%20photography&width=600&height=400&seq=kakobuy-preview-safety&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-shipping-polska",
    title: "Kakobuy Shipping Polska",
    desc: "Wszystko o wysyłce do Polski — dostępne linie, koszty, czas dostawy i jak uniknąć problemów z cłem.",
    tag: "Dostawa",
    tagIcon: "ri-ship-line",
    image: "https://readdy.ai/api/search-image?query=Cardboard%20box%20on%20warm%20cream%20desk%20next%20to%20laptop%20with%20delivery%20map%20on%20screen%2C%20soft%20natural%20light%2C%20minimalist%20logistics%20photography%2C%20international%20shipping%20concept%2C%20warm%20beige%20tones%2C%20clean%20organized%20workspace%2C%20calm%20aesthetic&width=600&height=400&seq=kakobuy-preview-shipping&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-finds-polska",
    title: "Kakobuy Finds Polska",
    desc: "50 najlepszych produktów wybranych przez społeczność. Sneakersy, hoodie, elektronika i akcesoria — sprawdzone perełki.",
    tag: "TOP Produkty",
    tagIcon: "ri-sparkling-line",
    image: "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20trendy%20fashion%20items%20on%20warm%20cream%20surface%2C%20sneakers%20hoodie%20sunglasses%20accessories%2C%20soft%20natural%20morning%20light%2C%20minimalist%20product%20discovery%20photography%2C%20warm%20earthy%20beige%20tones%2C%20editorial%20treasure%20hunting%20concept%2C%20clean%20aesthetic&width=600&height=400&seq=kakobuy-preview-finds&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-opinie",
    title: "Kakobuy Opinie",
    desc: "Szczera analiza tego, co polscy użytkownicy mówią o Kakobuy. Oceny, recenzje i prawdziwe doświadczenia zakupowe.",
    tag: "Opinie",
    tagIcon: "ri-message-2-line",
    image: "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20at%20warm%20cream%20desk%20with%20coffee%2C%20reading%20reviews%20concept%2C%20soft%20natural%20morning%20light%2C%20minimalist%20consumer%20research%20photography%2C%20warm%20beige%20tones%2C%20calm%20focused%20atmosphere%2C%20european%20lifestyle%20editorial&width=600&height=400&seq=kakobuy-preview-opinie&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-haul-polska",
    title: "Kakobuy Haul Polska",
    desc: "Przegląd autentycznych zamówień z Kakobuy. Unboxing, pierwsze wrażenia i porady dotyczące składania własnego haula.",
    tag: "Haul",
    tagIcon: "ri-shopping-bag-3-line",
    image: "https://readdy.ai/api/search-image?query=Open%20box%20with%20fashion%20items%20spilling%20out%20on%20warm%20cream%20desk%2C%20hoodie%20and%20sneakers%20being%20unboxed%2C%20soft%20natural%20light%2C%20minimalist%20unboxing%20photography%2C%20warm%20beige%20tones%2C%20excitement%20of%20receiving%20package%2C%20clean%20aesthetic&width=600&height=400&seq=kakobuy-preview-haul&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-lista-produktow",
    title: "Kakobuy Lista Produktów",
    desc: "Kompletny katalog wszystkich 14 kategorii dostępnych w arkuszu. Od shoes po akcesoria — sprawdź pełną listę.",
    tag: "Katalog",
    tagIcon: "ri-list-check-2",
    image: "https://readdy.ai/api/search-image?query=Organized%20grid%20of%20diverse%20fashion%20product%20categories%20on%20warm%20cream%20backdrop%2C%20sneakers%20hoodies%20jackets%20accessories%20in%20clean%20sections%2C%20soft%20natural%20daylight%2C%20minimalist%20catalog%20photography%2C%20warm%20beige%20tones%2C%20comprehensive%20product%20overview&width=600&height=400&seq=kakobuy-preview-lista&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-shoes-spreadsheet",
    title: "Kakobuy Shoes Spreadsheet",
    desc: "Najlepsze sneakersy i obuwie w jednym miejscu. Przewodnik po kategorii Shoes — style, ceny i porady zakupowe.",
    tag: "Shoes",
    tagIcon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=Multiple%20pairs%20of%20different%20style%20sneakers%20arranged%20on%20warm%20cream%20textured%20surface%2C%20white%20retro%20chunky%20sporty%20shoes%2C%20soft%20natural%20window%20light%2C%20minimalist%20footwear%20collection%2C%20warm%20beige%20tones%2C%20sneaker%20catalog%20editorial%2C%20clean%20modern%20aesthetic&width=600&height=400&seq=kakobuy-preview-shoes&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-hoodie-spreadsheet",
    title: "Kakobuy Hoodie Spreadsheet",
    desc: "Streetwear i moda w najlepszych cenach. Przewodnik po kategorii Hoodie/Sweaters — style, jakość i trendy.",
    tag: "Hoodie",
    tagIcon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Folded%20hoodies%20in%20neutral%20beige%20gray%20cream%20on%20warm%20linen%20surface%2C%20soft%20natural%20light%2C%20minimalist%20streetwear%20photography%2C%20warm%20earthy%20tones%2C%20clean%20scandinavian%20aesthetic%2C%20casual%20wear%20editorial%2C%20fabric%20texture%20visible%2C%20cozy%20atmosphere&width=600&height=400&seq=kakobuy-preview-hoodie&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-jak-korzystac",
    title: "Jak korzystać z Kakobuy",
    desc: "Poradnik krok po kroku dla początkujących. Od rejestracji, przez wyszukiwanie produktów, aż po bezpieczną wysyłkę.",
    tag: "Poradnik",
    tagIcon: "ri-book-open-line",
    image: "https://readdy.ai/api/search-image?query=Hands%20on%20laptop%20keyboard%20at%20warm%20cream%20desk%20with%20notebook%20and%20coffee%2C%20instructional%20guide%20concept%2C%20soft%20natural%20morning%20light%2C%20minimalist%20learning%20photography%2C%20warm%20beige%20tones%2C%20calm%20focused%20atmosphere%2C%20step%20by%20step%20tutorial%20feeling&width=600&height=400&seq=kakobuy-preview-jak&orientation=landscape",
  },
];

export default function ArticlePreview() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-primary-100 px-4 py-1.5 rounded-full mb-4">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-file-text-line text-primary-500 text-sm"></i>
            </span>
            <span className="text-xs font-semibold text-primary-700 whitespace-nowrap">
              Poradniki i artykuły
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Kakobuy Spreadsheet — Artykuły i Poradniki
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Poznaj wszystkie aspekty korzystania z Kakobuy Spreadsheet w Polsce. Od bezpieczeństwa po szczegółowe przewodniki kategorii.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all hover:border-accent-300/60 cursor-pointer"
            >
              <div className="w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className={`${article.tagIcon} text-accent-500 text-xs`}></i>
                  </span>
                  <span className="text-xs text-accent-700 font-medium whitespace-nowrap">
                    {article.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-accent-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-accent-500 text-background-50 font-semibold px-8 py-3.5 rounded-full hover:bg-accent-600 transition-all text-sm whitespace-nowrap cursor-pointer"
          >
            Otwórz Kakobuy Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}